module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x320-e41f906b1847a4cc97df6b0369ea2225.webp";